import React, { useState, useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { HomePage } from "./pages/HomePage";
import { AboutPage } from "./pages/AboutPage";
import { ServicesPage } from "./pages/ServicesPage";
import { GalleryPage } from "./pages/GalleryPage";
import { CompliancePage } from "./pages/CompliancePage";
import { ContactPage } from "./pages/ContactPage";
import { WhyUsPage } from "./pages/WhyUsPage";
import JsonData from "./data/data.json";
import SmoothScroll from "smooth-scroll";
import "./App.css";

/** Scroll to top on every route change */
const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
};

/** Floating buttons shown on all pages */
const FloatingButtons = () => {
  const [showScrollTop, setShowScrollTop] = useState(false);
  useEffect(() => {
    const handle = () => setShowScrollTop(window.scrollY > 300);
    window.addEventListener("scroll", handle);
    return () => window.removeEventListener("scroll", handle);
  }, []);
  return (
    <>
      <a
        href="https://wa.me/971504173911"
        target="_blank"
        rel="noopener noreferrer"
        className="whatsapp-float"
        aria-label="Chat on WhatsApp"
      >
        <i className="fa fa-whatsapp"></i>
      </a>
      {showScrollTop && (
        <button
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          className="scroll-to-top"
          aria-label="Scroll to top"
        >
          <i className="fa fa-chevron-up"></i>
        </button>
      )}
    </>
  );
};

const App = () => {
  const [data, setData] = useState({});

  useEffect(() => {
    setData(JsonData);
    new SmoothScroll('a[href*="#"]', {
      speed: 800,
      speedAsDuration: true,
      easing: "easeInOutCubic",
      offset: 50,
      updateURL: false,
    });
  }, []);

  // Don't render until data is loaded (avoids flash of missing props)
  if (!data.Contact) return null;

  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route path="/"            element={<HomePage       data={data} />} />
        <Route path="/about"       element={<AboutPage      data={data} />} />
        <Route path="/services"    element={<ServicesPage   data={data} />} />
        <Route path="/gallery"     element={<GalleryPage    data={data} />} />
        <Route path="/compliance"  element={<CompliancePage data={data} />} />
        <Route path="/contact"     element={<ContactPage    data={data} />} />
        <Route path="/why-us"      element={<WhyUsPage      data={data} />} />
        {/* 404 fallback → home */}
        <Route path="*"            element={<HomePage       data={data} />} />
      </Routes>
      <FloatingButtons />
    </BrowserRouter>
  );
};

export default App;

